import { call, put, takeLatest } from 'redux-saga/effects';
import * as type from '../constants/actionConstants';
import * as actions from '../actions/LoyaltyGiftAction.js';
import {
  getListMyGift,
getAllForCategoryServ,
  getAllWithImageServ,
  createRedeemTransaction,
  getListMenuCategoryServ,
  getDetailGiftServ,
  getListMyGiftPaServ,
  updateStatusGiftInforServ,
  getCityCodeServ,
  getProfileByCGifServ,
  checkMiniGameServ,
} from '../services/LoyaltyGiftService';
import { toast } from 'react-toastify';
import { isNullOrEmpty } from '../../functions';

export function* getListMyGiftAction({ payload }) {
  try {
    const repos = yield call(getListMyGift, payload);
    yield put(actions.getListMyGiftActionSuccess(repos));
  } catch (err) {}
}

export function* getDetailGiftAction({ payload }) {
  try {
    const repos = yield call(getDetailGiftServ, payload);
    yield put(actions.getDetailGiftActionSuccess(repos));
  } catch (err) {}
}

export function* getAllForCategory({ payload }) {
  try {
    const repos = yield call(getAllForCategoryServ, payload);
    yield put(actions.getAllForCategorySuccess(repos));
  } catch (err) {}
}

export function* createRedeemTransactionAction({ payload }) {
  try {
    const repos = yield call(createRedeemTransaction, payload);
    yield put(actions.createRedeemTransactionActionSuccess(repos));
    if (!isNullOrEmpty(repos) && repos.responseStatus === 200) {
      toast.success(
        'Quà tặng đã được đổi thành công. Quý khách vui lòng kiểm tra trong “Quà của tôi.”'
      );
    } else {
      if (repos.responseStatus === 604) {
        toast.error('Rất tiếc bạn không đủ điểm để đổi quà tặng.');
      } else {
        toast.error(repos.responseMessage);
      }
    }
  } catch (err) {}
}

export function* updateStatusGiftInforAction({ payload }) {
  try {
    const repos = yield call(updateStatusGiftInforServ, payload);
    yield put(actions.updateStatusGiftInforActionSuccess(repos));
    if (!isNullOrEmpty(repos) && repos.responseStatus === 200) {
      toast.success('Xác nhận thành công!');
    } else {
      toast.error(repos.responseMessage);
    }
  } catch (err) {}
}

export function* getAllOwnUsedGiftAction({ payload }) {
  try {
    const repos = yield call(getListMyGiftPaServ, payload);
    yield put(actions.getListMyGiftUsedOwnActionSuccess(repos));
  } catch (err) {}
}
export function* getAllOwnUnusedGiftAction({ payload }) {
    try {
    const repos = yield call(getListMyGiftPaServ, payload);
    yield put(actions.getListMyGiftUnusedOwnActionSuccess(repos));
  } catch (err) {}
}

export function* getAllWithImage({ payload }) {
  try {
    const repos = yield call(getAllWithImageServ, payload);
    yield put(actions.getAllWithImageSuccess(repos));
  } catch (err) {}
}

export function* getListMenuCategoryAction({ payload }) {
  try {
    const repos = yield call(getListMenuCategoryServ, payload);
    yield put(actions.getListMenuCategoryActionSuccess(repos));
  } catch (err) {}
}

export function* getCityCodeAction({ payload }) {
  try {
    const repos = yield call(getCityCodeServ, payload);
    yield put(actions.getCityCodeActionSuccess(repos));
  } catch (err) {}
}

export function* getVillageCodeAction({ payload }) {
  try {
    const repos = yield call(getCityCodeServ, payload);
    yield put(actions.getVillageCodeActionSuccess(repos));
  } catch (err) {}
}
export function* getTownCodeAction({ payload }) {
  try {
    const repos = yield call(getCityCodeServ, payload);
    yield put(actions.getTownCodeActionSuccess(repos));
  } catch (err) {}
}

export function* getListMyGiftPaAction({ payload }) {
  try {
    const repos = yield call(getListMyGiftPaServ, payload);
    yield put(actions.getListMyGiftPaActionSuccess(repos));
  } catch (err) {}
}

export function* getProfileByCGif({ payload }) {
  try {
    // yield put(actions.setChallengeDetail(true))
    const repos = yield call(getProfileByCGifServ, payload);

    yield put(actions.getProfileByCGifSuccess(repos));
  } catch (err) {}
}

export function* checkMiniGamePaAction({ payload }) {
  try {
    // yield put(actions.setChallengeDetail(true))
    const repos = yield call(checkMiniGameServ, payload);

    yield put(actions.checkMiniGameActionSuccess(repos));
  } catch (err) {}
}

export const loyaltyGift = [
  takeLatest(type.loyaltyAccInfoConst.GIFT_GETALL_BYMEMBERCODE, getListMyGiftAction),
  takeLatest(type.loyaltyAccInfoConst.GET_LOYALTY_OWNGIFT_USED, getAllOwnUsedGiftAction),
  takeLatest(type.loyaltyAccInfoConst.GET_LOYALTY_OWNGIFT_UNUSED, getAllOwnUnusedGiftAction),
  takeLatest(type.loyaltyAccInfoConst.GIFT_VOUCHE_DETAIL, getDetailGiftAction),
  takeLatest(type.loyaltyAccInfoConst.GIFT_GETALL_GETALLFORCATEGORY, getAllForCategory),
  takeLatest(type.loyaltyAccInfoConst.GIFT_CREAT_REDEEM_TRANSACTION, createRedeemTransactionAction),
  takeLatest(type.loyaltyAccInfoConst.GIFT_INFOR_UPDATE_STATUS, updateStatusGiftInforAction),
takeLatest(type.loyaltyAccInfoConst.GIFT_GETALL_GETALLWITHIMAGE, getAllWithImage),
  takeLatest(type.loyaltyAccInfoConst.GIFT_CATEGORY_GETALL_MENU, getListMenuCategoryAction),
  takeLatest(type.loyaltyAccInfoConst.GIFT_MODAL_REDEEM_GIFT_CITYCODE, getCityCodeAction),
  takeLatest(type.loyaltyAccInfoConst.GIFT_MODAL_REDEEM_GIFT_TOWNCODE, getTownCodeAction),
  takeLatest(type.loyaltyAccInfoConst.GIFT_MODAL_REDEEM_GIFT_VILLAGECODE, getVillageCodeAction),
  takeLatest(type.loyaltyAccInfoConst.LOYALTY_ACC_PROFILE_MEMBER, getProfileByCGif),
  takeLatest(type.loyaltyAccInfoConst.GIFT_CREAT_REDEEM_HISTORY, getListMyGiftPaAction),
  takeLatest(type.loyaltyAccInfoConst.GIFT_CHECK_MINIGAME, checkMiniGamePaAction),
];
